<seaged-form-factory *ngIf="sectionConfig.ui == 'metadata'" [form]="form"
                     [idNegocio]="sectionConfig.metadataFormId"
                     (onDoneForm)="onDoneForm($event)" [readOnlyForm]="readOnlyForm"></seaged-form-factory>


<lib-documentos *ngIf="sectionConfig.ui === 'documentos-proyecto'" [expediente]="expediente"
                [expedienteConfig]="expediente.configuracionExpediente"
                [config]="sectionConfig"
                [readOnly]="readOnlyForm"
                [descargaZipByFolio]="descargaZipByFolio"
                [skipByVersion]="skipByVersion"
>
</lib-documentos>

<mapas-container *ngIf="this.sectionConfig.ui === 'georeferencia' || this.sectionConfig.ui === 'evk-google-maps'"
                 [config]="sectionConfig" [paso]="sectionConfig" [readOnly]="readOnlyForm" [initPoint]="getPointToMap()">
</mapas-container>
